(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[139],{

/***/ "1Ak6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.jsx + 11 modules
var Card = __webpack_require__("786X");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// CONCATENATED MODULE: ./src/client/components/lines/product-flash-info-line/ProductFlashInfoLine.jsx


var __jsx = react_default.a.createElement;





var ProductFlashInfoLine_ProductFlashInfoLine = function ProductFlashInfoLine(_ref) {
  var close = _ref.config.common.close,
      editorialZone = _ref.editorialZone,
      id = _ref.id,
      seeMore = _ref.seeMore,
      title = _ref.title;

  if (!editorialZone) {
    return null;
  }

  var image = editorialZone.image,
      link = editorialZone.link,
      texts = editorialZone.texts;

  var _texts = Object(slicedToArray["a" /* default */])(texts, 3),
      _texts$ = _texts[0],
      headingTitle = _texts$ === void 0 ? '' : _texts$,
      _texts$2 = _texts[1],
      headingSubtitle = _texts$2 === void 0 ? '' : _texts$2,
      _texts$3 = _texts[2],
      text = _texts$3 === void 0 ? '' : _texts$3;

  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, __jsx(LineTitle["a" /* LineTitle */], null, title), __jsx(Card["a" /* Card */], {
    closeLabel: close,
    ctaLabel: seeMore,
    heading: {
      title: headingTitle,
      subtitle: headingSubtitle
    },
    link: {
      url: link
    },
    media: {
      alt: headingTitle,
      ratioKey: ratios_utils["c" /* default */].XS,
      url: image
    },
    text: {
      seeMoreLabel: seeMore,
      text: text
    }
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-flash-info/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductFlashInfoLine_ProductFlashInfoLine);

/***/ }),

/***/ "786X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Card_Card; });

// NAMESPACE OBJECT: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_namespaceObject = {};
__webpack_require__.r(Card_layouts_namespaceObject);
__webpack_require__.d(Card_layouts_namespaceObject, "Inline1", function() { return Card_layouts_Inline1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Inline2", function() { return Card_layouts_Inline2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column1", function() { return Card_layouts_Column1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column2", function() { return Column2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Composite1", function() { return Card_layouts_Composite1; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.themes.js

var defaultTheme = {
  thCta: 'font-bold underline',
  thCtaDefaultColor: colors["a" /* COLORS */].BLACK
};
var themes = {
  "default": defaultTheme,
  thumbnail: defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.jsx




var __jsx = react_default.a.createElement;







var CardBody_CardBody = function CardBody(_ref) {
  var ctaLabel = _ref.ctaLabel,
      dataTestIdPrefix = _ref.dataTestIdPrefix,
      _ref$displayLoadMore = _ref.displayLoadMore,
      displayLoadMore = _ref$displayLoadMore === void 0 ? true : _ref$displayLoadMore,
      isTablet = _ref.isTablet,
      layout = _ref.layout,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? {} : _ref$text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thCta = _themes$theme.thCta,
      thCtaDefaultColor = _themes$theme.thCtaDefaultColor;
  var isCollapsable = displayLoadMore && (!isTablet || [Card_constants["a" /* COLUMN_1 */], Card_constants["b" /* COLUMN_2 */]].includes(layout));
  return __jsx(react["Fragment"], null, __jsx(TextSeeMore["a" /* TextSeeMore */], Object(esm_extends["a" /* default */])({}, text, {
    dataTestIdPrefix: dataTestIdPrefix,
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: isCollapsable,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel
  })), __jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, link, {
    className: Object(classnames_utils["a" /* classnames */])(thCta, {
      'mt-20': text === null || text === void 0 ? void 0 : text.text
    }),
    color: thCtaDefaultColor,
    iconName: icons["a" /* ICONS */].ARROW_TAIL_RIGHT,
    label: ctaLabel
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.themes.js
var CardHeading_themes_themes = {
  "default": {
    thTitleTheme: 'title-brand-n2',
    thSmall: 'font-normal font-sans text-12',
    thSubtitle: 'text-sienna',
    thSubtitleTheme: 'title-sans-n2'
  },
  thumbnail: {
    thTitleTheme: 'title-brand-n3',
    thSmall: 'font-normal font-sans text-10',
    thSubtitle: 'text-sienna',
    thSubtitleTheme: 'title-sans-n2'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.jsx



var CardHeading_jsx = react_default.a.createElement;





var CardHeading_CardHeading = function CardHeading(_ref) {
  var color = _ref.color,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'CardHeading' : _ref$dataTestIdPrefix,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 2 : _ref$hLevel,
      iconName = _ref.iconName,
      link = _ref.link,
      small = _ref.small,
      subtitle = _ref.subtitle,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!title) {
    return null;
  }

  var _themes$theme = CardHeading_themes_themes[theme],
      thSmall = _themes$theme.thSmall,
      thSubtitle = _themes$theme.thSubtitle,
      thSubtitleTheme = _themes$theme.thSubtitleTheme,
      thTitleTheme = _themes$theme.thTitleTheme; // eslint-disable-next-line clubmed/no-fake-component

  var withLink = function withLink(node) {
    return (link === null || link === void 0 ? void 0 : link.url) ? CardHeading_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return withLink(CardHeading_jsx(react["Fragment"], null, CardHeading_jsx(Title["a" /* Title */], {
    dataTestId: "".concat(dataTestIdPrefix, "-title"),
    hLevel: hLevel,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && CardHeading_jsx("small", {
    className: thSmall
  }, small)), !!subtitle && CardHeading_jsx(Title["a" /* Title */], {
    className: Object(classnames_utils["a" /* classnames */])(thSubtitle, "text-".concat(color || 'black')),
    dataTestId: "".concat(dataTestIdPrefix, "-subtitle"),
    hLevel: hLevel < 6 ? hLevel + 1 : 6,
    theme: thSubtitleTheme
  }, subtitle)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.themes.js
var CardHeader_themes_defaultTheme = {
  thIntro: 'mt-20'
};
var CardHeader_themes_themes = {
  "default": CardHeader_themes_defaultTheme,
  thumbnail: CardHeader_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.jsx


var CardHeader_jsx = react_default.a.createElement;




var CardHeader_CardHeader = function CardHeader(_ref) {
  var color = _ref.color,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'CardHeader' : _ref$dataTestIdPrefix,
      heading = _ref.heading,
      introduction = _ref.introduction,
      link = _ref.link,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var thIntro = CardHeader_themes_themes[theme].thIntro;
  return CardHeader_jsx("header", null, CardHeader_jsx(CardHeading_CardHeading, Object(esm_extends["a" /* default */])({}, heading, {
    color: color,
    dataTestIdPrefix: dataTestIdPrefix,
    link: link,
    theme: theme
  })), !!introduction && CardHeader_jsx(Text["a" /* Text */], Object(esm_extends["a" /* default */])({}, introduction, {
    className: thIntro,
    "data-testid": "".concat(dataTestIdPrefix, "-introduction")
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/is-image/index.js
var is_image = __webpack_require__("JFtY");
var is_image_default = /*#__PURE__*/__webpack_require__.n(is_image);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Img.jsx + 1 modules
var Img = __webpack_require__("X6TF");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.utils.js
var Video_utils = __webpack_require__("JhHq");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.themes.js
var VideoWithFullScreen_themes_themes = {
  "default": {
    thThumbnailButton: 'hover:opacity-75 relative transition-opacity duration-250 ease-in w-full',
    thThumbnailButtonLabel: 'sr-only',
    thThumbnailIcon: 'absolute bg-black/60 leading-0 m-10 top-0 p-10 right-0 text-white',
    thThumbnailIconSize: '1.5625rem',
    thVideo: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.jsx
var VideoWithFullScreen_jsx = react_default.a.createElement;









function VideoWithFullScreen(props) {
  var buttonLabel = props.buttonLabel,
      className = props.className,
      closeLabel = props.closeLabel,
      ratioKey = props.ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      thumbnail = props.thumbnail,
      title = props.title,
      url = props.url;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  if (!Object(Video_utils["b" /* isVideoUrl */])(url)) {
    return null;
  }

  if (!thumbnail) {
    return VideoWithFullScreen_jsx(Video["a" /* Video */], {
      className: className,
      ratioKey: ratioKey,
      url: url
    });
  }

  var _themes$theme = VideoWithFullScreen_themes_themes[theme],
      thIframe = _themes$theme.thIframe,
      thThumbnailButton = _themes$theme.thThumbnailButton,
      thThumbnailIcon = _themes$theme.thThumbnailIcon,
      thThumbnailIconSize = _themes$theme.thThumbnailIconSize,
      thThumbnailButtonLabel = _themes$theme.thThumbnailButtonLabel,
      thVideo = _themes$theme.thVideo;
  return VideoWithFullScreen_jsx(react["Fragment"], null, VideoWithFullScreen_jsx("button", {
    className: Object(classnames_utils["a" /* classnames */])(thThumbnailButton, className),
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    },
    type: "button"
  }, VideoWithFullScreen_jsx("span", {
    classnames: thThumbnailButtonLabel
  }, buttonLabel), VideoWithFullScreen_jsx(Image["a" /* Image */], {
    imageUrl: thumbnail,
    ratioKey: ratioKey
  }), VideoWithFullScreen_jsx("div", {
    className: thThumbnailIcon
  }, VideoWithFullScreen_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MEDIA_VIDEO,
    width: thThumbnailIconSize
  }))), isExpanded && VideoWithFullScreen_jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setExpanded(!isExpanded);
    }
  }, VideoWithFullScreen_jsx(Video["a" /* Video */], {
    className: thVideo,
    iFrameClassName: thIframe,
    ratioKey: ratioKey,
    url: url
  })));
}
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.themes.js

var CardMedia_themes_defaultTheme = {
  thImageRatio: ratios_utils["c" /* default */].M,
  thVideo: 'bg-black'
};
var CardMedia_themes_themes = {
  "default": CardMedia_themes_defaultTheme,
  thumbnail: CardMedia_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.jsx


var CardMedia_jsx = react_default.a.createElement;











var CardMedia_CardMedia = function CardMedia(_ref) {
  var children = _ref.children,
      closeLabel = _ref.closeLabel,
      hasFullScreenMode = _ref.hasFullScreenMode,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {} : _ref$media,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  var _themes$theme = CardMedia_themes_themes[theme],
      thVideo = _themes$theme.thVideo,
      thImageRatio = _themes$theme.thImageRatio;
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'fullScreen',
    labelGA: "blockTitle_".concat(title)
  });

  var _useState = Object(react["useState"])(false),
      shouldDisplayFullScreen = _useState[0],
      setShouldDisplayFullScreen = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      zoomLevel = _useState2[0],
      setZoomLevel = _useState2[1]; // eslint-disable-next-line clubmed/no-fake-component


  var withLink = function withLink(node) {
    return node && link && link.url ? CardMedia_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return CardMedia_jsx(react["Fragment"], null, is_image_default()(media.url || '') ? withLink(CardMedia_jsx(react["Fragment"], null, hasFullScreenMode && CardMedia_jsx(react["Fragment"], null, CardMedia_jsx("button", {
    onClick: function onClick() {
      setShouldDisplayFullScreen(true);
      track();
    },
    className: "absolute end-0 top-0 m-15 rounded-2 bg-white p-5 leading-0 text-black shadow-sm transition-bg-color duration-250 ease-in hocus:bg-black/60 hocus:text-white",
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].EXPAND,
    width: "1.25rem"
  })), shouldDisplayFullScreen && CardMedia_jsx(Backdrop["a" /* Backdrop */], {
    onClose: function onClose() {
      setShouldDisplayFullScreen(false);
      setZoomLevel(0);
    },
    hasCloseButton: true
  }, zoomLevel === 0 ? CardMedia_jsx(Img["a" /* Img */], {
    dontChangeAnything: true,
    altMsg: media.alt,
    url: media.url,
    ratioDisplay: 1
  }) : CardMedia_jsx("div", {
    className: "max-h-full overflow-scroll"
  }, CardMedia_jsx(Img["a" /* Img */], {
    dontChangeAnything: true,
    altMsg: media.alt,
    url: media.url,
    ratioDisplay: 1,
    className: "mx-auto block",
    style: {
      maxWidth: "".concat(100 + zoomLevel * 100, "%")
    }
  })), CardMedia_jsx("div", {
    className: "absolute bottom-0 flex gap-x-10 p-20"
  }, CardMedia_jsx("button", {
    className: "animation-duration-500 relative top-0 z-3 flex size-26 items-center justify-center rounded-2 bg-white text-12 leading-0 text-black shadow transition-colors duration-250 ease-in ltr:animate-slideInRight rtl:animate-slideInLeft",
    onClick: function onClick() {
      zoomLevel <= 4 ? setZoomLevel(zoomLevel + 1) : setZoomLevel(5);
    },
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PLUS
  })), CardMedia_jsx("button", {
    className: "animation-duration-500 relative top-0 z-3 flex size-26 items-center justify-center rounded-2 bg-white text-12 leading-0 text-black shadow transition-colors duration-250 ease-in ltr:animate-slideInRight rtl:animate-slideInLeft",
    onClick: function onClick() {
      zoomLevel >= 1 ? setZoomLevel(zoomLevel - 1) : setZoomLevel(0);
    },
    type: "button"
  }, CardMedia_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].MINUS
  }))))), CardMedia_jsx(Image["b" /* default */], {
    altMsg: media.alt,
    imageUrl: media.url,
    ratioKey: media.ratioKey || thImageRatio,
    ratioDisplay: media.ratioDisplay || 1 / 2
  }))) : CardMedia_jsx(VideoWithFullScreen, {
    buttonLabel: media.thumbnailLabel,
    className: thVideo,
    closeLabel: closeLabel,
    thumbnail: media.thumbnail || '',
    title: media.title,
    url: media.url
  }), withLink(children));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_jsx = react_default.a.createElement;


var mediaClasses = 'overflow-hidden relative';
var Card_layouts_Inline1 = function Inline1(header, body, media, dataTestIdForTextDiv) {
  return Card_layouts_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-start gap-20 sm:justify-between"
  }, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12 sm:w-1/2')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'sm:w-1/2': media
    }),
    "data-testid": dataTestIdForTextDiv
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Inline2 = function Inline2(header, body, media, dataTestIdForTextDiv) {
  return Card_layouts_jsx("div", {
    className: "flex flex-col sm:flex-row-reverse sm:items-start gap-20 sm:justify-between"
  }, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12 sm:w-1/2')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])({
      'sm:w-1/2': media
    }),
    "data-testid": dataTestIdForTextDiv
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Column1 = function Column1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12')
  }, media), header && Card_layouts_jsx("div", {
    className: media && 'mt-20'
  }, header), body && Card_layouts_jsx("div", {
    className: (media || header) && 'mt-20'
  }, body));
};
var Column2 = function Column2(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "h-full overflow-hidden rounded-12 shadow-subtle"
  }, media && Card_layouts_jsx("div", {
    className: "-mx-1 -mt-1"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: "p-20"
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-20'
  }, body)));
};
var Card_layouts_Composite1 = function Composite1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(mediaClasses, 'rounded-12')
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-col sm:flex-row gap-20', {
      'mt-20': media
    })
  }, header && Card_layouts_jsx("div", {
    className: "sm:flex-1"
  }, header), body && Card_layouts_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('sm:flex-1', {
      'mt-20': header
    })
  }, body)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.jsx

var Card_jsx = react_default.a.createElement;







var Card_Card = function Card(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      color = _ref.color,
      ctaLabel = _ref.ctaLabel,
      customMedia = _ref.customMedia,
      dataTestIdPrefix = _ref.dataTestIdPrefix,
      displayLoadMore = _ref.displayLoadMore,
      hasFullScreenMode = _ref.hasFullScreenMode,
      heading = _ref.heading,
      id = _ref.id,
      introduction = _ref.introduction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? Card_constants["d" /* INLINE_1 */] : _ref$layout,
      link = _ref.link,
      media = _ref.media,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var hasTitle = Boolean(heading === null || heading === void 0 ? void 0 : heading.title);
  var hasCta = Boolean(ctaLabel);
  var header = !(introduction === null || introduction === void 0 ? void 0 : introduction.text) && !hasTitle ? null : Card_jsx(CardHeader_CardHeader, {
    color: color,
    dataTestIdPrefix: dataTestIdPrefix,
    heading: heading,
    introduction: introduction,
    link: hasCta ? null : link,
    theme: theme
  });
  var body = !(text === null || text === void 0 ? void 0 : text.text) && !hasCta ? null : Card_jsx(CardBody_CardBody, {
    ctaLabel: ctaLabel,
    dataTestIdPrefix: dataTestIdPrefix,
    displayLoadMore: displayLoadMore,
    isTablet: isTablet,
    layout: layout,
    link: link,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text,
    theme: theme
  });
  var picture = !(media === null || media === void 0 ? void 0 : media.url) && !customMedia ? null : Card_jsx(CardMedia_CardMedia, {
    closeLabel: closeLabel,
    hasFullScreenMode: hasFullScreenMode,
    link: hasCta || hasTitle ? null : link,
    media: media,
    theme: theme,
    title: heading === null || heading === void 0 ? void 0 : heading.title
  }, customMedia);
  return body || header || picture ? Card_jsx("article", {
    className: className,
    id: id
  }, Card_layouts_namespaceObject[layout](header, body, picture, dataTestIdPrefix)) : null;
};

/***/ }),

/***/ "JFtY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("oNVP");
var imageExtensions = __webpack_require__("y147");
var exts = Object.create(null);

imageExtensions.forEach(function (el) {
	exts[el] = true;
});

module.exports = function (filepath) {
	return path.extname(filepath).slice(1).toLowerCase() in exts;
};


/***/ }),

/***/ "JhHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoUrl; });
/* unused harmony export getVideoThumbnail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoUrl; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);





var youtubeRegEx = new RegExp('https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)');
var youkuRegEx = new RegExp('https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)');

function getYoutubeVideoUrl(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://www.youtube.com/embed/".concat(urlId[1]) : null;
}

function getYoutubeThumbnail(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://img.youtube.com/vi/".concat(urlId[1], "/sddefault.jpg") : null;
}

function getYoukuVideoUrl(url) {
  var urlId = youkuRegEx.exec(url);
  var clientId = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get('youku.clientId');
  return urlId ? "https://player.youku.com/embed/".concat(urlId[1], "?client_id=").concat(clientId) : null;
}

function getVideoUrl(url) {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function getVideoThumbnail(url) {
  return getYoutubeThumbnail(url);
}

function isVideoUrl(url) {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}



/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
      dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? 'TextSeeMore' : _ref$dataTestIdPrefix,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeMoreColor = _ref.seeMoreColor,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "dataTestIdPrefix", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeMoreColor", "seeLessLabel", "seeMoreLabel", "seeMoreSize"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_3__[/* SeeMore */ "a"], {
    className: className,
    color: seeMoreColor,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_4__[/* Text */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, textProps, {
    "data-testid": "".concat(dataTestIdPrefix, "-text")
  })));
};

/***/ }),

/***/ "akds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("D0nZ");
/* harmony import */ var _Video_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JhHq");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






function Video(props) {
  var className = props.className,
      iFrameClassName = props.iFrameClassName,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].L : _props$ratioKey,
      url = props.url;

  if (!Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* isVideoUrl */ "b"])(url)) {
    return null;
  }

  return __jsx(_image_placeholder_ImagePlaceholder__WEBPACK_IMPORTED_MODULE_4__[/* ImagePlaceholder */ "a"], {
    aspectRatio: 100 * _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "c"].VALUES[ratioKey],
    className: className
  }, __jsx(react_lazyload__WEBPACK_IMPORTED_MODULE_2___default.a, {
    className: "bg-no-repeat bg-center bg-cover leading-0 flex h-full items-center justify-center overflow-hidden rounded-12",
    once: true,
    offset: 100
  }, __jsx("iframe", {
    loading: "lazy",
    title: "Video iframe",
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])(iFrameClassName, 'border-0 animate-fadeIn animation-duration-500 h-[54vw] w-[96vw] max-h-full lazy'),
    src: Object(_Video_utils__WEBPACK_IMPORTED_MODULE_5__[/* getVideoUrl */ "a"])(url),
    allowFullScreen: true
  })));
}

/***/ }),

/***/ "oNVP":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "syQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INLINE_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INLINE_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLUMN_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPOSITE_1; });
var INLINE_1 = 'Inline1';
var INLINE_2 = 'Inline2';
var COLUMN_1 = 'Column1';
var COLUMN_2 = 'Column2';
var COMPOSITE_1 = 'Composite1';

/***/ }),

/***/ "uFXj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "y147":
/***/ (function(module) {

module.exports = JSON.parse("[\"ase\",\"art\",\"bmp\",\"blp\",\"cd5\",\"cit\",\"cpt\",\"cr2\",\"cut\",\"dds\",\"dib\",\"djvu\",\"egt\",\"exif\",\"gif\",\"gpl\",\"grf\",\"icns\",\"ico\",\"iff\",\"jng\",\"jpeg\",\"jpg\",\"jfif\",\"jp2\",\"jps\",\"lbm\",\"max\",\"miff\",\"mng\",\"msp\",\"nitf\",\"ota\",\"pbm\",\"pc1\",\"pc2\",\"pc3\",\"pcf\",\"pcx\",\"pdn\",\"pgm\",\"PI1\",\"PI2\",\"PI3\",\"pict\",\"pct\",\"pnm\",\"pns\",\"ppm\",\"psb\",\"psd\",\"pdd\",\"psp\",\"px\",\"pxm\",\"pxr\",\"qfx\",\"raw\",\"rle\",\"sct\",\"sgi\",\"rgb\",\"int\",\"bw\",\"tga\",\"tiff\",\"tif\",\"vtf\",\"xbm\",\"xcf\",\"xpm\",\"3dv\",\"amf\",\"ai\",\"awg\",\"cgm\",\"cdr\",\"cmx\",\"dxf\",\"e2d\",\"egt\",\"eps\",\"fs\",\"gbr\",\"odg\",\"svg\",\"stl\",\"vrml\",\"x3d\",\"sxd\",\"v2d\",\"vnd\",\"wmf\",\"emf\",\"art\",\"xar\",\"png\",\"webp\",\"jxr\",\"hdp\",\"wdp\",\"cur\",\"ecw\",\"iff\",\"lbm\",\"liff\",\"nrrd\",\"pam\",\"pcx\",\"pgf\",\"sgi\",\"rgb\",\"rgba\",\"bw\",\"int\",\"inta\",\"sid\",\"ras\",\"sun\",\"tga\"]");

/***/ })

}]);